import React from 'react';
import { Heart, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/siyarasoi-logo.jpg" 
                alt="Siyarasoi Foundation Logo" 
                className="h-16 w-16 object-contain rounded-full"
              />
              <div>
                <span className="text-xl font-bold text-white block">Siyarasoi Foundation</span>
                <span className="text-sm text-teal-300 italic">अन्नदान ही महादान</span>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              Committed to providing free, nutritious meals to those in need across the Ayodhya region.
            </p>
            <p className="text-sm text-emerald-400 font-medium">
              Anndan hi Mahadaan - Donation of food is the greatest donation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="hover:text-teal-400 transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('mission')} className="hover:text-teal-400 transition-colors">
                  Our Mission
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('impact')} className="hover:text-teal-400 transition-colors">
                  Impact
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('help')} className="hover:text-teal-400 transition-colors">
                  How to Help
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-teal-400 transition-colors">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Get Involved</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('help')} className="hover:text-teal-400 transition-colors">
                  Donate
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('help')} className="hover:text-teal-400 transition-colors">
                  Volunteer
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-teal-400 transition-colors">
                  Partnership
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-teal-400 transition-colors">
                  Corporate Support
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="text-teal-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-sm">Ayodhya Region, Uttar Pradesh, India</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="text-teal-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-sm">+91 XXX XXX XXXX</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="text-teal-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-sm">contact@siyarasoi.org</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Siyarasoi Foundation. All rights reserved.
            </p>
            <p className="text-sm text-gray-400 flex items-center">
              Made with <Heart className="text-red-500 mx-1" size={14} /> for the community
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
